import {
  ActionIcon,
  ActionIconProps,
  Tooltip,
  TooltipProps,
} from "@mantine/core";

import SvgIconRaw from "~/components/SvgIconRaw";

type InfoButtonProps = ActionIconProps & {
  info: TooltipProps["label"];
  tooltipProps?: Partial<TooltipProps>;
};

const InfoButton = ({ info, tooltipProps, ...props }: InfoButtonProps) => {
  return (
    <Tooltip label={info} {...tooltipProps}>
      <ActionIcon
        bd="none"
        color="gray"
        style={{ verticalAlign: "bottom" }}
        variant="transparent"
        {...props}
      >
        <SvgIconRaw name="InfoOutlined" size="1em" />
      </ActionIcon>
    </Tooltip>
  );
};

export default InfoButton;
